export const noVersionFound = `
> [!WARNING]
> This version provides no further information.
`;
